<template>

      <div class="head-container-container">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-12 col-sm-12 col-xs-12 col-lg-10 col-xl-9 col-xxl-9">
          <div class="head-container">
            <div class="left-placeholder" v-if="!showBackButton"><span id="logo" class="doto"
                style="font-size: 1.5rem;">demoparty</span></div>
            <div class="btn-styled top-btn" v-if="showBackButton" v-on:click="goto()"><i class="bi bi-chevron-left"></i></div>
            <div class="right-menu">
              <ContextMenu ref="contextMenu" teleport>
                <template #trigger>
                  <div class="menu-trigger btn-styled top-btn">
                    <i class="bi bi-three-dots" v-if="!rIsLoading"></i>
                    <div class="spinner-border" role="status" v-if="rIsLoading" style="width: 1.2rem; height: 1.2rem;">
                      <span class="visually-hidden">{{ $t('common.loading') }}</span>
                    </div>
                  </div>
                </template>
                <ContextMenuItem v-if="!rUser" icon="bi bi-box-arrow-in-right" @click="navigateTo('/login')">
                  {{ $t('common.login') }}
                </ContextMenuItem>
                <template v-if="rUser">
                  <ContextMenuItem icon="bi bi-person" @click="navigateTo('/settings?tab=account')">
                    <b><u>{{ displayUsername }}</u></b>
                  </ContextMenuItem>
                </template>
                <ContextMenuItem v-if="!hasActiveSubscription" icon="bi bi-bag-heart" @click="navigateTo('/subscribe')">
                  {{ $t('common.subscribe') }}
                </ContextMenuItem>
                <ContextMenuSeparator />
                <ContextMenuItem>
                  <RadioButton
                    :text="$t('common.local')"
                    :modelValue="rStorageType === 'local'"
                    @update:modelValue="selectStorage('local')"
                  />
                </ContextMenuItem>
                <ContextMenuItem v-if="rUser">
                  <RadioButton
                    :text="$t('common.cloud')"
                    :modelValue="rStorageType === 'remote'"
                    @update:modelValue="selectStorage('remote')"
                  />
                </ContextMenuItem>
                <ContextMenuSeparator />
                <ContextMenuItem icon="bi bi-house" @click="navigateTo('/')">
                  {{ $t('common.home') }}
                </ContextMenuItem>
                <ContextMenuItem icon="bi bi-search" @click="openSearch">
                  {{ $t('common.search') }}
                </ContextMenuItem>
                <ContextMenuItem icon="bi bi-gear" @click="navigateTo('/settings')">
                  {{ $t('common.settings') }}
                </ContextMenuItem>
                <ContextMenuItem icon="bi bi-question-circle" @click="navigateTo('/help')">
                  {{ $t('common.help') }}
                </ContextMenuItem>
                <ContextMenuItem v-if="rUser" icon="bi bi-door-closed" @click="logout()">
                  {{ $t('common.logout') }}
                </ContextMenuItem>
              </ContextMenu>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="spacer" style="height: 5.5rem;"></div>

</template>

<script>

import storageService from '@/scripts/services/StorageService';
import { hapticMixin } from '@/scripts/haptic';
import eventBus from '@/scripts/utils/eventBus';
import RadioButton from '@/components/UI/RadioButton.vue';
import ContextMenu from '@/components/UI/ContextMenu.vue';
import ContextMenuItem from '@/components/UI/ContextMenuItem.vue';
import ContextMenuSeparator from '@/components/UI/ContextMenuSeparator.vue';

export default {
    name: "TopBarComponent",
    components: {
        RadioButton,
        ContextMenu,
        ContextMenuItem,
        ContextMenuSeparator
    },
    mixins: [hapticMixin],
    data(){
        return{
            typed: "",
            timeout: null
        }
    },
    computed:{
        rStorageType() {
            return storageService.state.storageType
        },
        rIsLoading(){
            return storageService.state.isLoading
        },
        rUser(){
          return storageService.state.user || (storageService.state.isAuthorized ? {
            id: storageService.state.userId,
            username: storageService.state.username
          } : null)
        },
        displayUsername() {
            return this.rUser?.username || storageService.state.username || this.rUser?.email || this.$t('topBar.accountFallback')
        },
        hasActiveSubscription(){
            return storageService.hasActiveSubscription()
        },
        showBackButton() {
            const path = this.$route?.path || '';
            return path !== '/' && !path.startsWith('/link/');
        },
        canGoBack() {
            return Boolean(this.$router?.options?.history?.state?.back);
        }
    },
    mounted(){
      this.refreshUserProfile()
      const trigger = 'caramell';
      // Store handler reference for cleanup
      this._keydownHandler = (e) => {
            // Backspace/Escape для навигации назад (не в input/textarea)
            if ((e.key === 'Backspace' || e.key === 'Escape') && this.showBackButton) {
                const tag = e.target.tagName.toLowerCase();
                const isEditable = e.target.isContentEditable;
                if (tag !== 'input' && tag !== 'textarea' && !isEditable) {
                    e.preventDefault();
                    this.goto();
                    return;
                }
            }

            this.typed += e.key.toLowerCase();
            if (this.typed.length > trigger.length) {
                this.typed = this.typed.slice(-trigger.length);
            }
            if (this.typed === trigger) {
                const logo = document.getElementById('logo');
                if (logo) {
                    logo.classList.add('caramelldansen');
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                        logo.classList.remove('caramelldansen');
                    }, 5000);
                }
                this.typed = '';
            }
        };
      document.addEventListener('keydown', this._keydownHandler);
    },
    beforeUnmount() {
        // Remove keydown listener
        if (this._keydownHandler) {
            document.removeEventListener('keydown', this._keydownHandler);
            this._keydownHandler = null;
        }
        // Clear any pending timeout
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
    },
    methods: {
        openSearch() {
            this.$refs.contextMenu?.close()
            eventBus.$emit('open-command-palette')
        },
        refreshUserProfile() {
            storageService.loadUserProfile()
        },
        goto(){
            if (this.canGoBack) {
                this.$router.back();
            } else {
                this.$router.push('/');
            }
            this.$refs.contextMenu?.close();
        },
        showTestNotification() {
            this.triggerHaptic();
            eventBus.notify('Test Notification', 'This is a test notification from the TopBar component!');
        },
        showStorageError() {
            this.triggerHaptic();
            // Simulate a storage error by calling logError on a non-existent method
            storageService.logError(new Error('This is a test storage error'), 'testMethod');
        },
        navigateTo(path) {
            this.$router.push(path);
            this.$refs.contextMenu?.close();
        },
        selectStorage(type) {
            this.triggerHaptic();
            if (storageService.state.storageType !== type) {
                storageService.switchStorages()
                this.$router.push('/');
            }
        },
        logout(){
          storageService.logout();
        }
    }
}

</script>

<style>

.head-container-container {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
}

.head-container {
  margin-top: 1rem;
  /*background-color: #2F2F2F;*/
  background: rgba(47, 47, 47, 0.55);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(47, 47, 47, 0.61);
  backdrop-filter: blur(12.3px);
  -webkit-backdrop-filter: blur(12.3px);
  padding: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  border-radius: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /*box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;*/
}

.btn-styled {
  background: rgba(47, 47, 47, 0.8);
  padding: 8px 12px;

  border: 1px solid rgba(47, 47, 47, 1);

  border-radius: 6px;
  cursor: pointer;
  text-align: center;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 6px 0px;
  transition: box-shadow 240ms cubic-bezier(.2, .8, .2, 1),
    transform 240ms cubic-bezier(.2, .8, .2, 1),
    background-color 240ms ease;
}

.btn-styled:hover {
  background-color: #393939;
  box-shadow: rgba(39, 39, 39, 0.15) 0px 5px 6px 0px;
  transform: scale(1.01);
}

.top-btn {
  box-shadow: none !important;
}

.right-menu {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}


.caramelldansen {
  animation: rainbow 2s linear infinite, pulse 0.6s ease-in-out infinite;
  text-shadow:
    0 0 10px currentColor,
    0 0 20px currentColor,
    0 0 30px currentColor,
    0 0 40px currentColor;
}

@keyframes rainbow {
  0% {
    color: #ff0080;
  }

  14% {
    color: #ff8000;
  }

  28% {
    color: #ffff00;
  }

  42% {
    color: #00ff00;
  }

  57% {
    color: #00ffff;
  }

  71% {
    color: #0080ff;
  }

  85% {
    color: #8000ff;
  }

  100% {
    color: #ff0080;
  }
}

@keyframes pulse {

  0%,
  100% {
    transform: scale(1);
    filter: brightness(1);
  }

  50% {
    transform: scale(1.05);
    filter: brightness(1.3);
  }
}

</style>
